<template>
  <div class="d-flex flex-column mr-3">
    <Panel
      :icon="['fas', 'bullseye']"
      loader-text="Loading Offer Details"
      :loading="loadingOfferDetails"
      :show-loading-error="showLoadingError"
      :loading-error-text="loadingErrorText"
    >
      <template v-slot:header>
        <span>Create RTT Request</span>
      </template>
      <template v-slot:content>
        <SellerOfferCreateRTTRequestForm 
          v-if="!loadingOfferDetails && !showLoadingError && selectedOfferRegistration"
          :seller-offer-registration="selectedOfferRegistration"
        />
      </template>
    </Panel>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SellerOfferCreateRTTRequestForm from './SellerOfferCreateRTTRequestForm.vue'

export default {
  name: 'SellerOfferCreateRTTRequest',

  title: 'Create RTT Request',

  components: {
    SellerOfferCreateRTTRequestForm,
  },

  props: {
    sellerOfferRegistrationId: {
      type: String,
      required: true
    },

    sellerOfferId: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      loadingOfferDetails: false,
      showLoadingError: false,
      loadingErrorText: '',
    }
  },

  computed: {
    ...mapGetters('sellerOffer', ['allOffersCombined']),

    selectedOfferRegistration() {
      return this.allOffersCombined.find(
        offer => offer.id === this.sellerOfferRegistrationId
      )
    }
  },

  async created() {
    await this.loadOfferDetails()
  },

  methods: {
    ...mapActions('sellerOffer', ['getSellerAvailableOffers', 'getSellerAppliedOffers']),

    async loadOfferDetails() {
      try {
        this.loadingOfferDetails = true
        this.showLoadingError = false
        
        await Promise.all([
          this.getSellerAvailableOffers(),
          this.getSellerAppliedOffers()
        ])

        // Check if we found the offer registration
        if (!this.selectedOfferRegistration) {
          throw new Error('Offer registration not found')
        }
      } catch (error) {
        this.showLoadingError = true
        this.loadingErrorText = error?.response?.data?.title || error.message || 'Error loading offer details'
      } finally {
        this.loadingOfferDetails = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>